import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'emailCheckbox',
    'allEmails'
  ]

  notificationChanged(event) {
    event.target.form.requestSubmit()
  }

  toggleAllEmails(event) {
    this.emailCheckboxTargets.map(el => {
      if (event.target.checked === true) {
        this.allEmailsTarget.innerText = 'On'
        el.checked = false
        el.disabled = true
      } else {
        this.allEmailsTarget.innerText = 'Off'
        el.checked = true
        el.disabled = false
      }
    })
    event.target.form.requestSubmit()
  }
}
